import { persistRightDrawerWidth } from '@app/shared/api/user'

import { createDrawerWidthLayout } from './drawer-width-layout'

export const RIGHT_DRAWER_MIN_WIDTH_PX = 340
export const RIGHT_DRAWER_MAX_WIDTH_PX = 800

export const rightDrawerLayout = createDrawerWidthLayout({
  drawerId: 'right-drawer',
  cssVariable: '--right-drawer-user-width',
  minWidthPx: RIGHT_DRAWER_MIN_WIDTH_PX,
  maxWidthPx: RIGHT_DRAWER_MAX_WIDTH_PX,
  anchoredEdge: 'right',
  persist: (px) => persistRightDrawerWidth(px),
})

export const {
  setWidthPx,
  readWidthPx,
  beginDragMeasurement,
  requestedWidthPx,
  maxAvailableWidthPx,
} = rightDrawerLayout
